var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import { useStore } from 'react-context-hook';
import { BsCheckLg } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { RoundLogo } from '@app/components/atm.logo/logo.component';
import { CenterModal } from '@app/modules/quiz/components/phase-completed/components/avaliation-modal/avaliation-modal.styled';
import { H1, H2 } from '@atomic';
export var Thanks = function (_a) {
    var logo = _a.logo;
    var company = useStore('company')[0];
    var id = useParams().id;
    return (React.createElement(CenterModal, null,
        React.createElement(RoundLogo, { src: logo }),
        React.createElement(H1, { style: { fontWeight: 'bold', fontSize: 22 } }, "Sua inscri\u00E7\u00E3o foi cancelada com sucesso!"),
        React.createElement(StyledIconWrapper, null,
            React.createElement(DashedCircle, null,
                React.createElement(BsCheckLg, { size: 150, color: "#008425" }))),
        React.createElement(H2, { style: { fontWeight: 'bold', fontSize: 20 } }, "Nossa equipe estar\u00E1 sempre dispon\u00EDvel para melhor atend\u00EA-lo. Obrigado!")));
};
var StyledIconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 40px;\n  margin-bottom: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  width: 100%;\n"], ["\n  margin-top: 40px;\n  margin-bottom: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  width: 100%;\n"])));
var DashedCircle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 200px;\n  height: 200px;\n  border: 3px dashed #008425;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 200px;\n  height: 200px;\n  border: 3px dashed #008425;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2;
